export default {
  "name": "zotero-plugin",
  "version": "9.0.1",
  "description": "Zotero plugin builder",
  "homepage": "https://github.com/retorquere/zotero-plugin/wiki",
  "type": "module",
  "main": "./dist/cjs/index.js",
  "module": "./dist/esm/index.js",
  "exports": {
    ".": {
      "import": "./dist/esm/index.js",
      "require": "./dist/cjs/index.cjs"
    },
    "./debug-log": {
      "import": "./dist/esm/debug-log.js",
      "require": "./dist/cjs/debug-log.cjs"
    },
    "./logger": {
      "import": "./dist/esm/logger.js",
      "require": "./dist/cjs/logger.cjs"
    },
    ".loader/json": {
      "import": "./dist/esm/loader/json.js",
      "require": "./dist/cjs/loader/json.cjs"
    },
    ".loader/peggy": {
      "import": "./dist/esm/loader/peggy.js",
      "require": "./dist/cjs/loader/peggy.cjs"
    },
    ".loader/pem": {
      "import": "./dist/esm/loader/pem.js",
      "require": "./dist/cjs/loader/pem.cjs"
    },
    "./copy-assets": {
      "import": "./dist/esm/bin/copy-assets.js",
      "require": "./dist/cjs/bin/copy-assets.cjs"
    },
    "./make-dirs": {
      "import": "./dist/esm/bin/make-dirs.js",
      "require": "./dist/cjs/bin/make-dirs.cjs"
    },
    "./make-manifest": {
      "import": "./dist/esm/bin/make-manifest.js",
      "require": "./dist/cjs/bin/make-manifest.cjs"
    },
    "./make-version": {
      "import": "./dist/esm/bin/version.js",
      "require": "./dist/cjs/bin/version.cjs"
    }
  },
  "author": {
    "name": "Emiliano Heyns",
    "email": "Emiliano.Heyns@iris-advies.com"
  },
  "scripts": {
    "preversion": "npm test",
    "postversion": "git push --follow-tags",
    "test": "dprint fmt *.ts */*.ts && dprint check *.ts */*.ts && npm run build",
    "prebuild": "rm -rf dist",
    "build": "tsup",
    "check": "tsc --noEmit",
    "start": "concurrently --raw --group 'npm run check' 'npm run build'",
    "pack": "npm test && npm pack",
    "prepublishOnly": "npm install && npm run build",
    "ncu": "ncu -u && npm i && git add package.json package-lock.json && git commit -m ncu"
  },
  "directories": {
    "test": "test"
  },
  "dependencies": {
    "@fluent/syntax": "^0.19.0",
    "@napi-rs/keyring": "^1.2.0",
    "@octokit/rest": "^22.0.1",
    "@rgrove/parse-xml": "^4.2.0",
    "@types/node": "^25.3.0",
    "@xmldom/xmldom": "^0.9.8",
    "ajv": "^8.18.0",
    "ajv-keywords": "^5.1.0",
    "archiver": "^7.0.1",
    "clp": "^4.0.13",
    "commander": "^14.0.3",
    "dotenv": "^17.3.1",
    "ejs": "^4.0.1",
    "fs-extra": "^11.3.3",
    "glob": "^13.0.6",
    "ini": "^6.0.0",
    "jose": "^6.1.3",
    "jsesc": "^3.1.0",
    "lodash": "^4.17.23",
    "moment": "^2.30.1",
    "node-forge": "^1.3.3",
    "node-stream-zip": "^1.15.0",
    "openpgp": "^6.3.0",
    "peggy": "^5.0.6",
    "prompts": "^2.4.2",
    "pug": "^3.0.3",
    "rimraf": "^6.1.3",
    "shell-quote": "^1.8.3",
    "shelljs": "^0.10.0",
    "string-to-arraybuffer": "^1.0.2",
    "ts-node": "^10.9.2",
    "tslib": "^2.8.1",
    "typescript": "^5.9.3",
    "uri-templates": "^0.2.0",
    "url-template": "^3.1.1",
    "uzip": "^0.20201231.0",
    "xml-parser": "^1.2.1",
    "xpath": "^0.0.34",
    "zotero-types": "^4.1.1"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/retorquere/zotero-plugin.git"
  },
  "license": "ISC",
  "files": [
    "package.json",
    "README.md",
    "dist"
  ],
  "bin": {
    "zp-release": "dist/cjs/bin/release.cjs",
    "zp-zipup": "dist/cjs/bin/zipup.cjs",
    "zp-link": "dist/cjs/bin/link.cjs",
    "issue-branches": "dist/cjs/bin/branches.cjs",
    "zotero-start": "dist/cjs/bin/start.cjs",
    "zp-fetch-log": "dist/cjs/bin/fetch-log.cjs",
    "zp-keypair": "dist/cjs/bin/keypair.cjs",
    "zp-copy-assets": "dist/cjs/copy-assets.cjs",
    "zp-make-dirs": "dist/cjs/make-dirs.cjs",
    "zp-manifest": "dist/cjs/make-manifest.cjs",
    "zp-version": "dist/cjs/version.cjs"
  },
  "bugs": {
    "url": "https://github.com/retorquere/zotero-plugin/issues"
  },
  "devDependencies": {
    "@openpgp/web-stream-tools": "^0.3.0",
    "concurrently": "^9.2.1",
    "dprint": "^0.51.1",
    "esbuild": "^0.27.3",
    "tsup": "^8.5.1"
  }
}
